import { apiClient } from "@/api/modules/base";
import { type AxiosPromise } from "axios";
import type { DocumentsListRequest } from "./types/documentListRequest";
import type { DocumentsListResponse } from "./types/documentsListResponse";
import { documentFileRoute, Route } from "@/api/modules/datasheet/documents/routes.ts";


export const search = (payload: DocumentsListRequest): AxiosPromise<DocumentsListResponse> =>
    apiClient.post(Route.DocumentsList, payload);

export const getFile = (assetId: number): AxiosPromise<Blob> =>
    apiClient.get(documentFileRoute(assetId), {
        responseType: "blob",
        suppressForbiddenRedirect: true
    });
